import React from 'react';
import { useIntl } from 'react-intl';
import { commonNameAttributes, identifiableName } from '@/utils/resultsHelper';
import ActionDialogForm from './ActionDialogForm';
import ActionDialogConfirmation from './ActionDialogConfirmation';
import ActionDialogItems from './ActionDialogItems';

const ActionDialogContent = ({
  action = 'delete',
  children,
  className,
  inProgress,
  entities,
  entity,
  hide,
  icon,
  identifiers = commonNameAttributes,
  items,
  modalIcon = 'trash',
  onSubmit,
  simple,
  theme,
}) => {
  const intl = useIntl();
  const [confirmText, setConfirmText] = React.useState('');
  const name = identifiableName(items, identifiers);

  const minimumDataEntryMet = () => ((simple || items.length > 1)
    ? confirmText.toLowerCase() === intl.formatMessage({ id: 'actions.yes' }).toLowerCase()
    : confirmText === name);

  const handleClose = () => {
    setConfirmText('');
    hide();
  };

  const submitForm = () => {
    onSubmit({ items });
    setConfirmText('');
  };

  return (
    <ActionDialogForm
      action={action}
      className={className}
      entity={entity}
      entities={entities}
      hide={hide}
      inProgress={inProgress}
      items={items}
      minimumDataEntryMet={minimumDataEntryMet()}
      modalIcon={modalIcon}
      identifiers={identifiers}
      onClick={submitForm}
      onClose={handleClose}
      simple={simple}
      theme={theme}
    >
      <ActionDialogConfirmation
        action={action}
        disabled={inProgress}
        entity={entity}
        entities={entities}
        items={items}
        minimumDataEntryMet={minimumDataEntryMet}
        onChange={setConfirmText}
        submitForm={submitForm}
        text={confirmText}
      />
      {items.length > 1 && (
      <ActionDialogItems action={action} icon={icon} entities={entities}>
        {children}
      </ActionDialogItems>
      )}
    </ActionDialogForm>
  );
};

export default ActionDialogContent;
